import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container py-4">
      <h2 className="mb-3">Privacy Policy</h2>

      <p>
        This Privacy Policy describes how KC School ("we", "our", or "us") collects, uses, and protects the personal information of parents and guardians ("you" or "your") who use the KC School Parent App.
      </p>

      <h4>1. Information We Collect</h4>
      <p>We collect the following types of information to provide and improve our services:</p>
      <ul>
        <li><strong>Student Information:</strong> Name, registration number, class, section, attendance, academic performance, and transport details.</li>
        <li><strong>Parent Information:</strong> Name, phone number, email address (if provided), and relationship to the student.</li>
        <li><strong>Device Information:</strong> Device type, operating system, and usage data to help us improve app performance.</li>
      </ul>

      <h4>2. How We Use Your Information</h4>
      <p>Your information is used to:</p>
      <ul>
        <li>Provide academic updates, attendance, and transport tracking</li>
        <li>Send notifications about school events, circulars, and emergency alerts</li>
        <li>Enable communication between parents and school administrators or teachers</li>
        <li>Ensure account security and app functionality</li>
      </ul>

      <h4>3. Data Sharing</h4>
      <p>We do not sell, rent, or trade your personal information. Your data may be shared only with:</p>
      <ul>
        <li>Authorized KC School staff for administrative or academic purposes</li>
        <li>Service providers involved in app hosting and notification delivery, under strict confidentiality</li>
        <li>Government authorities, if required by law</li>
      </ul>

      {/* <h4>4. Data Security</h4>
      <p>
        We implement appropriate technical and organizational measures to safeguard your data against unauthorized access, loss, or misuse.
      </p> */}

      <h4>4. Your Rights</h4>
      <p>You have the right to:</p>
      <ul>
        <li>Access and review the information related to your child</li>
        <li>Request corrections if any data is inaccurate</li>
        <li>Request deletion of your account or personal data, subject to school policy</li>
      </ul>

      <h4>5. Children’s Privacy</h4>
      <p>
        The app is intended for use by parents or guardians. Student information is accessible only by authorized users.
      </p>

      <h4>6 Changes to This Policy</h4>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted within the app and become effective immediately.
      </p>

      <h4>7. Contact Us</h4>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at:
        <br />
        <strong>Email:</strong> kcpublicschool@gmail.com<br />
        <strong>Phone:</strong> +91-680 222 1154<br />
        <strong>Address:</strong> Kamapalli Main Rd, near to Tata Benz, Chhak, Kamapalli, Behrampur, Odisha 760004
      </p>
    </div>
  );
};

export default PrivacyPolicy;
